import getSymbolFromCurrency from 'currency-symbol-map';
const getCurrencySymbol = currency => getSymbolFromCurrency(currency) || '';

// TODO chatai: Should be localed with Restaurants-agreed-formatter
export const getPaddedAmountWithCurrency = (amount, currency) => {
  const currencySymbol = getCurrencySymbol(currency);
  return `${currencySymbol}${amount}`;
};
export const getPaddedAmountWithPercentage = amount => `${amount}%`;
export const generateAmountText = (currencyOrPercentage, amount, currency) => {
  return currencyOrPercentage === 'percentage' ? getPaddedAmountWithPercentage(amount) : getPaddedAmountWithCurrency(amount, currency);
};
export const generateAppliedToText = applyBasedOnFulfillmentTypes => {
  const hasDelivery = applyBasedOnFulfillmentTypes == null ? void 0 : applyBasedOnFulfillmentTypes.deliveryOrders;
  const hasPickup = applyBasedOnFulfillmentTypes == null ? void 0 : applyBasedOnFulfillmentTypes.pickupOrders;
  if (hasDelivery && hasPickup) {
    return 'Delivery & Pickup orders';
  } else if (hasDelivery) {
    return 'Delivery orders';
  } else if (hasPickup) {
    return 'Pickup orders';
  } else {
    // Applied to all fulfillment types
    return 'All orders'; // TODO chatai: Understand if this is the string we want
  }
};
export const generateOrderSubtotalText = function (applyBasedOnSubtotal, currency) {
  if (currency === void 0) {
    currency = '';
  }
  if (!applyBasedOnSubtotal) {
    return '';
  }
  if ('amount' in applyBasedOnSubtotal) {
    const {
      amount
    } = applyBasedOnSubtotal;
    return getPaddedAmountWithCurrency(amount, currency);
  }
  const {
    minimumAmount,
    maximumAmount
  } = applyBasedOnSubtotal;
  return `Between ${getPaddedAmountWithCurrency(minimumAmount, currency)} - ${getPaddedAmountWithCurrency(maximumAmount, currency)}`;
};
//# sourceMappingURL=utils.js.map